module.exports = __webpack_public_path__ + "static/img/Discover.c3cc042.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Discover.png
// module id = Edjv
// module chunks = 1